import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@assets/scss/main.scss'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueScrollTo from 'vue-scrollto'
import VueToasted from 'vue-toasted'
import VeeValidate from 'vee-validate'
import messages from 'vee-validate/dist/locale/de'
import VuejsDialog from 'vuejs-dialog'
import { EventBus } from '@/assets/js/event-bus.js'
import BounceLoader from 'vue-spinner/src/BounceLoader.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import VModal from 'vue-js-modal'
import ImageComponent from './components/Image.vue'
import VueMultianalytics from 'vue-multianalytics'

VeeValidate.Validator.localize('de', messages)

const VeeValidateConfig = {
  locale: 'de'
}

Vue.use(VuejsDialog, {
  html: true,
  okText: 'Bestätigen',
  cancelText: 'Abbrechen'
})
Vue.use(VModal)
Vue.use(VueScrollTo)
Vue.use(VueAwesomeSwiper)
Vue.use(VueToasted, { router })
Vue.use(VeeValidate, VeeValidateConfig)
Vue.component('icon', Icon)
Vue.component('bounce-loader', BounceLoader)
Vue.component('clip-loader', ClipLoader)
Vue.component('beat-loader', BeatLoader)
Vue.component('scale-loader', ScaleLoader)
Vue.component('img-comp', ImageComponent)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  document.body.style.overflow = 'auto'
  document.body.style.height = '100%'
  document.body.style.width = '100%'
  document.body.style.position = 'initial'
  store.commit('GLOBAL_RESET_BUSY_METHOD')
  if (!store.getters.auth_is_authenticated && to.meta.requiresAuth) {
    store.commit('AUTH_SET_REDIRECT', {state: true, name: to.name, params: to.params})
    next('/')
    Vue.nextTick(() => {
      EventBus.$emit('toggleLoginModal')
    })
  } else {
    next()
  }
})

if (process.env.APP.tracking.enabled === '1') {
  let gaConfig = {
    appName: process.env.APP.name,
    appVersion: process.env.APP.version,
    trackingId: process.env.APP.tracking.ga,
    ecommerce: false,
    debug: false
  }
  let facebookConfig = {
    token: process.env.APP.tracking.facebook,
    debug: false
  }

  Vue.use(VueMultianalytics, {
    modules: {
      ga: gaConfig,
      facebook: facebookConfig
    },
    routing: {
      vueRouter: router,
      preferredProperty: 'name'
    }
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js